import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { withRouter } from '../../common/withRouter';
import {
  DataDefinitionList,
  Loader,
  Notification,
  Message,
  ButtonOBSOLETED,
} from "../../web.common";
import AriaModal from "react-aria-modal";
import { LayoutContext } from "../layout/siteLayout";
import PageTop from "../layout/PageTop";
import withApi from "../higherOrderComponents/withApi";
import { DisplayDate, DisplayGuid } from "../items";
import { DetailsRightBar, NoLink, Divider, Action } from "./DetailsRightBar";

const relayTypeAsString = {
  0: "UNKNOWN",
  1: "EXTERNAL MANUAL",
  2: "EXTERNAL MANUAL SKIP",
  3: "EXTERNAL AUTO",
  4: "EXTERNAL AUTO SKIP",
  5: "INTERNAL MANUAL",
  6: "INTERNAL AUTO EMAIL",
  7: "INTERNAL AUTO CONCIERGE",
  8: "INTERNAL DIRECT ACTIVITY",
  9: "FAKE",
};

class ConfirmationEmailInternal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      confirmationData: null,
      modalContent: null,
      signupId: null,
      notification: null,
      isBooking: null,
    };
  }

  async componentDidMount() {
    const {
      match: {
        params: { emailId },
      },
    } = this.props;
    const {
      api: {
        confirmationEmail: { getConfirmationById },
      },
    } = this.props;

    try {
      const confirmationData = await getConfirmationById(emailId);
      this.setState({ confirmationData });
    } catch (e) {
      this.setState({
        errorMessage: new Message("error", "Unable to get data"),
      });
    }
  }

  async confirmEmail(isBooking) {
    if (this.state.signupId == null || this.state.signupId.trim() == "") {
      this.setState({ notification: new Message('error', 'Insert a valid Guid') });
      return;
    }

    const result = await this.props.api.confirmationEmail.confirmSignup(
      this.state.confirmationData.id,
      this.state.signupId.trim(),
      isBooking
    );
    
    const messageStatus = result.success === true ? 'success' : 'error';

    this.setState({ notification: new Message(messageStatus, result.message) });
    const response = await this.props.api.confirmationEmail.getConfirmationById(
      this.props.match.params.emailId
    );
    this.setState({
      isConfirming: null,
      signupId: null,
      isBooking: null,
    });
    this.setState({ confirmationData: response });
  }

  showContent(e, contentToShow) {
    e.preventDefault();
    this.setState({
      modalContent: (
        <AriaModal
          titleText="Edit Field"
          mounted
          verticallyCenter={false}
          focusDialog
          getApplicationNode={() => document.getElementById("app")}
          dialogClass="dialog-size-normal"
          scrollDisabled
        >
          <iframe
            sandbox="allow-presentation"
            style={{ height: "600px" }}
            srcDoc={contentToShow}
          />
          <ButtonOBSOLETED
            buttonColor="gray"
            size="small"
            onClick={() => {
              this.setState({ modalContent: null });
            }}
            disabled={false}
            buttonContent="Back"
            ariaLabel="return"
          >
            Back
          </ButtonOBSOLETED>
        </AriaModal>
      ),
    });
  }

  render() {
    const {
      match: {
        params: { emailId },
      },
    } = this.props;
    const {
      confirmationData,
      notification,
      errorMessage,
      isConfirming,
      isBooking,
      signupId,
      modalContent,
      relayResult,
    } = this.state;

    let mappedData = null;

    if (confirmationData) {
      const {
        id,
        signupId,
        createdDate,
        seasonalCourtPurchaseId,
        from,
        to,
        subject,
        relayType,
        relayRuleId,
        isRead,
        isExternalEmail,
        isAttending,
        mute,
        isDirty,
        dirtyWords,
      } = confirmationData;

      mappedData = {
        Id: <DisplayGuid>{id}</DisplayGuid>,
        SignupId:
          signupId != null ? (
            <DisplayGuid baseAnchor={"../signup"}>{signupId}</DisplayGuid>
          ) : (
            ""
          ),
        CreatedDate: <DisplayDate>{createdDate}</DisplayDate>,
        ["Seasonal Court Purchase Id"]:
          seasonalCourtPurchaseId != null ? (
            <DisplayGuid baseAnchor={"../seasonalcourtpurchase"}>
              {seasonalCourtPurchaseId}
            </DisplayGuid>
          ) : (
            ""
          ),
        From: from,
        To: to,
        Subject: subject,
        ["Relay Type"]: relayTypeAsString[relayType],
        ["Relay Rule Id"]: relayRuleId || "",
        Html: (
          <Link
            to="#"
            onClick={(e) => this.showContent(e, confirmationData.html)}
          >
            show html
          </Link>
        ),
        CleanedHtml: (
          <Link
            to="#"
            onClick={(e) => this.showContent(e, confirmationData.cleanedHtml)}
          >
            show cleaned html
          </Link>
        ),
        Text: (
          <Link
            to="#"
            onClick={(e) => this.showContent(e, confirmationData.text)}
          >
            show text
          </Link>
        ),
        CleanedText: (
          <Link
            to="#"
            onClick={(e) => this.showContent(e, confirmationData.cleanedText)}
          >
            show cleaned text
          </Link>
        ),
        IsRead: isRead,
        IsExternalEmail: isExternalEmail,
        IsAttending: isAttending,
        Mute: mute,
        IsDirty: isDirty,
        DirtyWords: dirtyWords.length >= 1 ? JSON.stringify(dirtyWords) : "",
      };
    }

    return (
      <LayoutContext.Consumer>
        {() => (
          <React.Fragment>
          <Notification newMessage={notification}/>
            {modalContent}
            {isConfirming == "confirm" && (
              <AriaModal
                titleText="Confirm Signup"
                mounted
                verticallyCenter={false}
                focusDialog
                getApplicationNode={() => document.getElementById("app")}
                dialogClass="dialog-size-normal"
                scrollDisabled
              >
                <div>
                  <h3>
                    Confirmation for <br />
                    <h5 className="main-page-subheader">
                      {confirmationData.id}
                    </h5>
                  </h3>
                  <br />
                  <div style={{ display: "table", width: "100%" }}>
                    <label
                      style={{
                        display: "table-cell",
                        width: "30%",
                        whiteSpace: "nowrap",
                        fontWeight: "bold",
                      }}
                    >
                      Signup Id
                    </label>
                    <span
                      style={{ display: "table-cell", padding: "0 4px 0 6px" }}
                    >
                      <input
                        placeholder="signupId..."
                        name="confirm-signup"
                        value={signupId}
                        onChange={(event) =>
                          this.setState({ signupId: event.target.value })
                        }
                      />
                    </span>
                  </div>
                  <hr />
                </div>
                <ButtonOBSOLETED
                  size="small"
                  onClick={() => {
                    this.confirmEmail(true);
                  }}
                  disabled={false}
                  buttonContent="Confirm"
                  ariaLabel="return"
                ></ButtonOBSOLETED>
                <ButtonOBSOLETED
                  buttonColor="gray"
                  size="small"
                  onClick={() => {
                    this.setState({
                      isConfirming: null,
                      signupId: null,
                      notification: null,
                      isBooking: null,
                    });
                  }}
                  disabled={false}
                  buttonContent="Back"
                  ariaLabel="return"
                ></ButtonOBSOLETED>
              </AriaModal>
            )}

            <div className="content-with-right-pane-delimiter">
              <PageTop
                documentTitle="Confirmation details"
                documentDescription="Confirmation details"
              />

              <h2 className="main-page-header main-page-header-with-subheader">
                Confirmation Email
              </h2>
              <h5 className="main-page-subheader">{emailId}</h5>
              <br />

              {mappedData ? (
                <React.Fragment>
                  <DataDefinitionList
                    listData={mappedData}
                    classNames={["detail-page-list"]}
                  />
                </React.Fragment>
              ) : (
                <Loader hasLoaded={false}>Loading...</Loader>
              )}
              {relayResult && (
                <>
                  <hr />
                  <article
                    style={{
                      backgroundColor: "white",
                      padding: "1rem",
                      border: "1px solid #e5e5e5",
                    }}
                  >
                    <h3>
                      <b>Result</b>
                    </h3>
                    <pre>{relayResult.explanation}</pre>
                    {relayResult.ruleId && (
                      <pre>RuleId: {relayResult.ruleId}</pre>
                    )}
                    {/*TODO improve*/}
                  </article>
                </>
              )}
            </div>

            <DetailsRightBar>
              <Divider>Links</Divider>
              <NoLink>None</NoLink>
              <Divider>Actions</Divider>

              {confirmationData && (
                <>
                  {confirmationData.signupId != null || confirmationData.seasonalCourtPurchaseId ? (
                    <>
                      <Action disabled action={() => {}}>
                        Confirmation Signup
                      </Action>
                      <Action disabled action={() => {}}>
                        Confirmation Cancellation
                      </Action>
                    </>
                  ) : (
                    <>
                      <Action
                        action={() => {
                          this.setState({
                            isConfirming: "confirm",
                            isBooking: true,
                          });
                        }}
                      >
                        Confirm Signup
                      </Action>
                      <Action
                        action={() => {
                          this.setState({
                            isConfirming: "confirm",
                            isBooking: false,
                          });
                        }}
                      >
                        Confirm Cancellation
                      </Action>
                    </>
                  )}
                </>
              )}

              {confirmationData &&
                (confirmationData.from.includes("wannasport") ? (
                  <Action disabled action={() => {}}>
                    Test the Relay
                  </Action>
                ) : (
                  <Action
                    action={async () => {
                      const {
                        api: {
                          confirmationEmail: { relayRun },
                        },
                      } = this.props;
                      this.setState({ relayResult: null });
                      var result = await relayRun(confirmationData.id);
                      this.setState({ relayResult: result.data });
                    }}
                  >
                    Test the Relay
                  </Action>
                ))}
            </DetailsRightBar>
          </React.Fragment>
        )}
      </LayoutContext.Consumer>
    );
  }
}

const ConfirmationEmail = withRouter(
  withApi(
    connect(
      ({ user }) => ({ isLoggedIn: !!user }),
      {}
    )(ConfirmationEmailInternal)
  )
);

ConfirmationEmail.requiresLogin = true;
ConfirmationEmail.propTypes = { isLoggedIn: PropTypes.bool };

export default ConfirmationEmail;
